{
	"id": 7819579,
	"numericId": 7819579,
	"collectionId": 789,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 104823,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator and Artificial Intelligence",
					"summary": "This module contains three simulation-based activities and a five-question end-of-module knowledge check. It will take approximately 40 to 60 minutes to complete the entire module.",
					"moduleNumber": 7,
					"activityCount": 3,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 50
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "brain-circuit",
									"title": "Human-in-the-loop in K to 12 AI use"
								}
							],
							"title": "Introduction"
						},
						{
							"items": [
								{
									"icon": "book-open",
									"title": "Learn"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "bot",
									"title": "Practice"
								},
								{
									"icon": "pen-tool",
									"title": "Reflect"
								},
								{
									"icon": "square-pen",
									"title": "Analysis"
								}
							],
							"title": "Scenario 1: AI Data Privacy in K to 12 Classrooms"
						},
						{
							"items": [
								{
									"icon": "book-open",
									"title": "Learn"
								},
								{
									"icon": "bot",
									"title": "Practice"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								}
							],
							"title": "Scenario 2: AI Decision Making"
						},
						{
							"items": [
								{
									"icon": "book-open",
									"title": "Learn"
								},
								{
									"icon": "bot",
									"title": "Practice"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								}
							],
							"title": "Scenario 3: Using Generative AI and Social Media Ethically"
						},
						{
							"title": "Module 7 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Identifying ethical issues related to the use of various artificial intelligence tools",
						"Evaluating competing tensions to make decisions aligned with ethical principles within a simulation",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 7010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104824,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Human‑in‑the‑loop (HITL) means that educators remain actively involved at every critical point when using artificial intelligence (AI) in education. Rather than delegating decisions to algorithms, teachers retain professional judgment, oversight, and accountability. AI may assist with tasks such as generating lesson ideas or analyzing assessment results, but educators are responsible for reviewing and interpreting AI outputs and deciding how, or whether, AI outputs are used with students. AI can support teaching, but it should never replace the educator’s final judgment.\n\nMaintaining HITL is essential because AI systems have well‑documented limitations. They can reflect bias, misinterpret context, or produce inaccurate outputs. Without human oversight, reliance on AI can undermine instructional quality, fairness, and student trust. For example, allowing AI to grade student work or determine instructional placements without a human review of the output risks ethical violations and conflicts with educators’ responsibility to provide thoughtful, equitable evaluation.\n\nEducators must retain responsibility because they are accountable professionals entrusted with students’ learning and well‑being. When AI produces questionable or harmful recommendations, such as misidentifying student needs or flagging valid work as plagiarism, teachers must apply professional discernment, correct errors, and prevent harm. Unlike algorithms, educators can consider context, student individuality, and alignment with curriculum and ethical standards.\n\nThis responsibility aligns directly with the *Model Code of Ethics for Educators* (*MCEE*), which calls on teachers to use assessments appropriately and to use data accurately, reliably, and ethically when guiding decisions. HITL serves as a practical safeguard that ensures that AI outputs are advisory, not authoritative, and that high‑stakes decisions remain human led.\n\nThe human-in-the-loop approach also supports broader ethical priorities such as equity, transparency, and trust. AI tools often operate on averages, while educators understand that students’ cultural, linguistic, and learning needs vary. Human oversight ensures that AI‑supported recommendations are adapted thoughtfully rather than applied mechanically. As described in the United States Department of Education’s guidance in *Artificial Intelligence and the Future of Teaching and Learning*, published in 2023, AI in education should function like an “electric bike,” enhancing human effort, rather than as an autonomous system that operates without direction.\n\nUltimately, HITL is not a preference but a professional and ethical obligation. Educators must vet AI tools for privacy and effectiveness, be transparent about when AI is used, and ensure that AI does not mislead or harm students. By remaining actively involved throughout the AI life cycle, from selecting tools to interpreting outputs to making final decisions, educators protect students, uphold professional ethics, and model responsible technology use.\n\nIn summary, a human‑in‑the‑loop approach ensures that AI serves as a supportive partner in teaching and learning, guided at every step by educators’ professional judgment and ethical responsibility.",
				"title": "Human-in-the-Loop (HITL) for AI Use in K to12 Classrooms"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 7020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104825,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving an ethical dilemma that educators encounter as they talk to colleagues about how to use artificial intelligence (AI) in ethical ways.",
				"learn": "Protecting student data privacy when using artificial intelligence (AI) tools is a core ethical responsibility for educators. AI data privacy refers to safeguarding students’ personal and educational information, such as names, work, or records, and ensuring that this information is used only in lawful and appropriate ways.\n\nMany AI tools used in schools collect data. For example, an AI tutoring program may record student responses, or an AI planning tool may analyze performance trends. Educators must ensure that no personally identifiable information (PII) is shared with AI tools that are not approved and secured. Examples of PII are names, photos, and detailed student work. State and district guidance advises teachers to avoid entering student PII into public or consumer AI tools and to use only district-vetted platforms that comply with privacy laws.\n\nKey risks associated with classroom AI include unintended disclosure of student data, bias, misuse, and overreliance on automated systems. Because AI tools can collect and store large amounts of information, educators must comply with federal laws such as the Family Educational Rights and Privacy Act (FERPA), which limits the sharing of student education records, and the Children’s Online Privacy Protection Act (COPPA), which requires parental consent for online services that collect data from children under 13 years of age.\n\n**Educator Responsibilities and Best Practices**\n\nPrinciple II.B in the* Model Code of Ethics for Educators* (*MCEE*) requires teachers to use “data, materials, research, and assessment” responsibly when adopting new technologies. In practice, this means adhering to the following guidelines.\n- **Follow privacy laws and school policies. **Use only AI tools approved by your district and never upload sensitive student information into systems without formal data protection. Consult administrators before using new tools and obtain parental consent when required.\n- **Use AI only for its intended educational purpose. **AI tools should support instruction; they should not replace professional judgment or be used for high-stakes decisions unless explicitly designed and validated for that purpose. Human oversight is required.\n- **Model ethical use and transparency.** Be open about when AI has been used to support instructional materials or analysis and avoid using AI in ways that compromise assessment validity or student trust. For example, student work should not be entered into public AI tools for grading or feedback.\n\nWhen used thoughtfully and responsibly, AI can support teaching and learning. However, educators remain accountable for protecting student privacy, exercising professional judgment, and ensuring that AI use serves learning ethically and fairly.",
				"title": "Scenario 1: Learn",
				"instruction": "First, you will read an overview to gain further insight into protecting student data privacy when you or a colleague uses AI to complete everyday tasks of teaching. Then, you will put that framing into practice by completing a simulation where you have a conversation with a colleague who is using AI in a questionable way. After completing the simulation, you will read feedback on how you engaged in the simulation and how your decisions aligned or came into conflict with the PROETHICS principles."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 3,
				"sourceId": 7030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104826,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 1: Explore",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "principle_explorer",
				"language": "en-US",
				"position": 4,
				"sourceId": 7040
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104827,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing a scenario where your colleague uses AI in a questionable way.",
				"media": [
					{
						"type": "IMAGE",
						"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-7/handwritten_journal_entry.png"
					}
				],
				"title": "Scenario 1: Practice",
				"scenario": "You are hosting a student teacher, Ms. Daria. You’ve asked her to grade a homework assignment your 6th-grade students completed that asked them to write detailed essays about what they did over summer vacation. These essays included names, locations, and aspects of family life – all personally identifiable information. A specific example is below:\n\nMs. Daria put the essays into ChatGPT to analyze along with a scoring rubric. Initiate a discussion with Ms. Daria to address any concerns around inputting the student essays in ChatGPT.",
				"instruction": "You will now have a conversation with Ms. Daria. When you talk to Ms. Daria, try to help her understand that non-district approved AI systems without proper safeguards can compromise students’ safety and well-being if given private information."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 5,
				"sourceId": 7050
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104828,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 1: Simulation",
				"prompt": "You will now have a conversation with Ms. Daria. When you talk to Ms. Daria, try to help her understand that non-district approved AI systems without proper safeguards can compromise students’ safety and well-being if given private information.",
				"persona": {
					"name": "Ms. Daria",
					"role": "Student Teacher",
					"description": "Ms. Daria is a Praxis-certified student teacher you are mentoring. She is eager and well meaning, but new to teaching, overwhelmed, and confident she handled the grading correctly."
				},
				"scenario": {
					"text": "You are hosting a student teacher, Ms. Daria. You’ve asked her to grade a homework assignment your 6th-grade students completed that asked them to write detailed essays about what they did over summer vacation. These essays included names, locations, and aspects of family life – all personally identifiable information. A specific example is below:\nMs. Daria put the essays into ChatGPT to analyze along with a scoring rubric. Initiate a discussion with Ms. Daria to address any concerns around inputting the student essays in ChatGPT.",
					"media": [
						{
							"type": "IMAGE",
							"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-7/handwritten_journal_entry.png"
						}
					]
				},
				"objectives": [
					"Identifying ethical issues related to the use of various artificial intelligence tools",
					"Evaluating competing tensions to make decisions aligned with ethical principles within a simulation",
					"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
				]
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_scenario",
				"language": "en-US",
				"position": 6,
				"sourceId": 7070,
				"scenarioId": "scenario-1"
			},
			"scoring": {
				"type": "AI_RUBRIC",
				"points": 12,
				"criteria": {
					"short_and_long_term_impacts": {
						"icon": "clock",
						"name": "Describes both short-term and long-term impacts of inputting student data into an AI system.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Names what can go wrong right away and over time when student data is entered into an AI tool. Shows the learner sees this as an ongoing risk, not a one-off mistake."
					},
					"retrieve_and_eliminate_student_data": {
						"icon": "trash-2",
						"name": "Proposes solutions to retrieve and eliminate student data from the AI system used.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Suggests concrete steps to remove the exposed data and prevent further sharing, such as contacting administration and stopping use of the tool. Moves the conversation from recognizing the problem to repairing it."
					},
					"student_data_wellbeing_and_safety_harms": {
						"icon": "shield-alert",
						"name": "Explains how inputting different types of student data into an AI system can harm the well-being and safety of students.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Connects the specific kinds of information shared (home address, family details, mental-health disclosures) to concrete safety and well-being harms. Goes beyond a general privacy concern to name the actual danger to the student."
					}
				}
			},
			"feedback": [
				{
					"type": "DYNAMIC",
					"language": "en-US"
				}
			],
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104829,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 1: Reflect",
				"instruction": "**Directions:** Review the feedback from your conversation with Ms. Daria to see what you did well and what can be improved."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_feedback",
				"language": "en-US",
				"position": 7,
				"sourceId": 7080,
				"scenarioId": "scenario-1"
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104830,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following three scenarios.",
				"cards": [
					{
						"id": "A",
						"back": {
							"text": "**Follow privacy laws and school policies.** Use only AI tools approved by your district and never upload sensitive student information into systems without formal data protection. Consult administrators before using new tools and obtain parental consent when required.",
							"title": "**Stewardship of the Law and Public Trust**"
						},
						"front": {
							"text": "Ms. Daria was impressed with what AI could do with some of her personal writing, so she was excited to see how well cutting-edge models could grade her students’ work."
						},
						"label": "Stewardship of the Law and Public Trust",
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
							}
						]
					},
					{
						"id": "B",
						"back": {
							"text": "**Use AI only for its intended educational purpose.** AI tools should support instruction, not replace professional judgment or be used for high stakes decisions unless explicitly designed and validated for that purpose. Human oversight is required.",
							"title": "**Ensuring Student Welfare**"
						},
						"front": {
							"text": "Ms. Daria thought that using a large language model (LLM) tool to grade student essays with a rubric meant that her grades would be consistent for all her students."
						},
						"label": "Ensuring Student Welfare",
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
							}
						]
					},
					{
						"id": "C",
						"back": {
							"text": "**Model ethical use and transparency.** Be open when AI has been used to support instructional materials or analysis and avoid using AI in ways that compromise assessment of validity or student trust. For example, student work should not be entered into public AI tools for grading or feedback.",
							"title": "**Transparency in Actions and Communications**"
						},
						"front": {
							"text": "Ms. Daria thought AI could help her quickly grade the student essays. If she didn’t tell anyone, no one would realize how far behind she actually was."
						},
						"label": "Transparency in Actions and Communications",
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
							}
						]
					}
				],
				"title": "Scenario 1: Analysis",
				"instruction": "**Directions:** Review each scenario card to understand how an educator might justify using AI in this situation. Then consider how each decision aligns, or conflicts, with PROETHICS principles. Each of the three cards has a front and back side with additional information."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_cards",
				"language": "en-US",
				"position": 8,
				"sourceId": 7060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104831,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving an ethical dilemma that educators encounter as they talk to colleagues about how to use artificial intelligence (AI) in ethical ways.",
				"learn": "**Decision Making Using AI and the Black Box Problem**\nMany advanced AI tools function as black boxes, which means that their inner workings are hidden and the user cannot determine how or why the system produced a given result. For example, an AI system might flag certain students as at risk or determine that an essay should receive a low score, but it will not provide an explanation of how it arrived at those judgments. This opacity creates a serious trust and accountability challenge for educators. Teachers are trained to base decisions on evidence and rationale, but many AI platforms do not provide evidence and reasoning. If an algorithm’s decision-making process is not interpretable, educators cannot confidently verify its accuracy or check for bias. Additionally, they cannot explain the decision to a concerned student or parent.\n\nTransparency and explainability are widely recognized as essential qualities for trustworthiness in educational AI. Explainability is the capacity of an AI system to describe its internal logic and justify its outcomes in clear, human-understandable language. However, there is often a trade-off: The most powerful AI models may also be the least explainable. Understanding the black box problem helps educators remain appropriately cautious. It reminds teachers that any AI suggestion, especially when used to make a decision for the classroom or students, should be reviewed with a critical eye, precisely because the underlying reasoning might be obscure.\n\n**Critical Thinking When Evaluating AI Outputs**\nBecause AI outputs are generated through complex statistical patterns rather than humanlike reasoning, it is crucial for educators to exercise strong critical thinking and not accept those outputs unquestioningly. A core aspect of AI literacy is understanding that many AI-generated answers are the product of training data and algorithms, and thus inherently fallible. In practice, this means treating an AI’s recommendation as a hypothesis or draft rather than a definitive truth. Teachers should verify AI-provided information against credible sources or their own expertise, examine the assumptions or gaps, and consider the context. For assessments, teachers should ensure that any AI-informed grading or feedback is correct and contextually appropriate.\n\nCritical thinking also involves being alert to bias. If an AI suggests an action that seems to disadvantage a particular student or group or seems based on stereotypes rather than individual merit, a thoughtful teacher will question it.\n\nCritical thinking ensures that educators use AI as a helpful aid only when its outputs meet the educators’ own standards of accuracy, fairness, and relevance. Ultimately, using critical thinking to evaluate AI outputs helps safeguard assessment validity and instructional quality. Critical thinking prevents unquestioning trust in machine outputs and reinforces the teacher’s role as an informed decision maker.",
				"title": "Scenario 2: Learn",
				"instruction": "First, you will read an overview to gain further insight into AI decision making when you or a colleague uses AI to complete everyday tasks of teaching. Then, you will put that framing into practice by completing a simulation where you have a conversation with a colleague who is using AI in a questionable way. After completing the simulation, you will read feedback on how you engaged in the simulation and how your decisions aligned or came into conflict with the PROETHICS principles."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 9,
				"sourceId": 7090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104832,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing a scenario where your colleague uses AI in a questionable way.",
				"title": "Scenario 2: Practice",
				"scenario": "Your fellow 5th grade teacher, Mr. Dennis, recently shared how he uses AI to generate homework assignments for his math class. Mr. Dennis described how they enter generic prompts (“Generate 5 math word problems for 5th graders about calculating percentages and dividing things up in the real world.”) and copy-paste the results for students to complete for homework.\n\nDiscussions among students began to circulate about the inappropriate nature of some of the questions in this teacher’s homework assignments, such as the following:\n\n- Timmy’s parents are getting a divorce. They have to split a $45,000 credit card bill. If Timmy’s dad takes on 60% of the debt, how much does his mom have to pay?\n- A bartender is mixing cocktails. IF a drink requires ¼ cup of vodka and ½ cup cranberry juice, what is the total volume of the drink?\n\nYou have concerns about the inappropriate content shared with students. Initiate a discussion with Mr. Dennis to address your concern about the materials shared with students and about their professional reputation.",
				"instruction": "You will now have a conversation with Mr. Dennis. When you talk to Mr. Dennis, try to help him understand how keeping humans-in-the-loop increases transparency and explainability when using AI-generated information, while supporting clear, defensible, and fair decisions when using AI systems."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 10,
				"sourceId": 7100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104833,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 2: Simulation",
				"prompt": "You will now have a conversation with Mr. Dennis. When you talk to Mr. Dennis, try to help him understand how keeping humans-in-the-loop increases transparency and explainability when using AI-generated information, while supporting clear, defensible, and fair decisions when using AI systems.",
				"persona": {
					"name": "Mr. Dennis",
					"role": "5th Grade Teacher",
					"description": "Mr. Dennis is a fellow 5th grade teacher with about five years of experience. He works hard, feels overloaded, uses AI to quickly generate homework assignments, and can become defensive when questioned because he believes the assignments are novel, efficient, and appropriate for students."
				},
				"scenario": {
					"text": "Your fellow 5th grade teacher, Mr. Dennis, recently shared how he uses AI to generate homework assignments for his math class. Mr. Dennis described how they enter generic prompts (“Generate 5 math word problems for 5th graders about calculating percentages and dividing things up in the real world.”) and copy-paste the results for students to complete for homework.\nDiscussions among students began to circulate about the inappropriate nature of some of the questions in this teacher’s homework assignments, such as the following:\nTimmy’s parents are getting a divorce. They have to split a $45,000 credit card bill. If Timmy’s dad takes on 60% of the debt, how much does his mom have to pay?\nA bartender is mixing cocktails. IF a drink requires ¼ cup of vodka and ½ cup cranberry juice, what is the total volume of the drink?\nYou have concerns about the inappropriate content shared with students. Initiate a discussion with Mr. Dennis to address your concern about the materials shared with students and about their professional reputation."
				},
				"objectives": [
					"Identifying ethical issues related to the use of various artificial intelligence tools",
					"Evaluating competing tensions to make decisions aligned with ethical principles within a simulation",
					"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
				]
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_scenario",
				"language": "en-US",
				"position": 11,
				"sourceId": 7110,
				"scenarioId": "scenario-2"
			},
			"scoring": {
				"type": "AI_RUBRIC",
				"points": 12,
				"criteria": {
					"ai_lacks_interpretable_processes": {
						"icon": "eye-off",
						"name": "States explicitly that an AI system lacks interpretable processes when it does not show how decisions or outputs are made.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Names that the AI is a black box whose reasoning cannot be inspected. Establishes why its output cannot be trusted without review."
					},
					"chooses_interpretable_ai_systems": {
						"icon": "scan-search",
						"name": "Specifically states that increasing transparency of AI systems involves choosing systems more likely to produce interpretable responses.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Explains that transparency improves when you choose tools that can show their logic and sources. Frames tool selection as an active, deliberate choice."
					},
					"provides_transparency_processes_or_examples": {
						"icon": "list-checks",
						"name": "Provides specific processes or examples of systems to do so.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Offers concrete methods or example tools that surface decision logic, such as prompting for reasoning and checking output before use. Turns the principle into actionable practice."
					}
				}
			},
			"feedback": [
				{
					"type": "DYNAMIC",
					"language": "en-US"
				}
			],
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104834,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 2: Reflect",
				"instruction": "**Directions:** Review the feedback from your conversation with Mr. Dennis to see what you did well and what can be improved."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_feedback",
				"language": "en-US",
				"position": 12,
				"sourceId": 7120,
				"scenarioId": "scenario-2"
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104835,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving an ethical dilemma that educators encounter as they talk to colleagues about how to use artificial intelligence (AI) in ethical ways.",
				"learn": "As generative AI becomes more common in social media and school-related communication, educators need a clear ethical framework for deciding how to use these tools responsibly, transparently, and in ways that protect students.\n\n**The Ethical Foundation: Student Safety, Professional Judgment, and Responsibility**\n\nAt the core of ethical decision making about generative AI and social media is a simple commitment: Student safety must come first. Consistent with the *MCEE* and the PROETHICS principles, educators are expected to protect students’ physical, emotional, and intellectual well-being whenever technology is used in shared online spaces (such as social media, class discussion platforms, or group messaging tools). This includes recognizing that AI tools can introduce bias, amplify stereotypes, spread inaccurate information, or expose students to harm. Teachers must take the necessary actions to prevent these negative outcomes.\n\n**Examples of Ethical Risks Educators Should Evaluate**\n- **AI-Generated Student Spotlights:** Before using AI to generate social media posts celebrating student achievements, teachers should evaluate whether the AI’s language or image selection reinforces stereotypes or disproportionately highlights certain demographic groups.\n- **AI Content Moderation:** When AI algorithms moderate classroom social media groups, teachers must monitor whether the system flags content from certain students more frequently, potentially reflecting bias in the training data.\n- **AI Recommendation Systems:** Social media platforms use AI to recommend content. Teachers should recognize that these algorithms may expose students to inappropriate content or create filter bubbles that limit diverse perspectives.\n\n**Key Ethical Expectations for Educators**\n\n**Transparency and disclosure** are essential for maintaining trust with students and families. The *MCEE* emphasizes honest, respectful interactions with learners, and district guidance often requires educators to be clear about when and how AI is being used. For example, if a teacher uses AI to generate discussion prompts or draft content for a class social media page, the teacher should explain that AI supported the work and clarify the teacher’s role in reviewing and approving the final content. This reinforces that ethical use of AI depends on openness, accountability, and human oversight.\n\n**Minimizing Risks to Students**\n\nDistrict and school policies commonly stress that AI should never be used in ways that violate student privacy, reinforce discrimination, or replace essential human interaction. In practice, this means that educators are responsible for reviewing AI-generated content carefully, understanding the limits of the tools they use, and making sure that technology supports, rather than weakens, ethical relationships with students. Educators should think of AI tools as aids that require supervision, not as substitutes for professional responsibility.\n\nThe following actions minimize student risk when using AI in social media.\n- **Verify accuracy of AI-generated content.** AI can generate false or misleading information. Before sharing AI-created social media posts about educational content, teachers must fact-check all information.\n- **Protect student data from AI training.** Many social media platforms use uploaded content to train AI models. Teachers should avoid posting student work or images on platforms that may incorporate this data into AI systems without consent.\n- **Monitor AI’s impact on student well-being.** Social media algorithms use AI to maximize engagement, which can negatively affect students’ mental health. Teachers should be aware of these risks and report concerns.\n- **Obtain informed consent.** Parents and guardians provide informed consent for their children’s digital activities by signing a school district’s Acceptable Use Policy. When using AI tools that process student data via social media, ensure parents understand how the AI works, what data it collects, and potential risks.\n\n**Ethical Use of Generative AI and Social Media in Practice**\n\nFor educators, ethical use of generative AI and social media can be summarized in a small set of clear professional commitments. These commitments reflect the PROETHICS principles and the *MCEE* and can help educators make valid choices in everyday situations.\n\n**Core Professional Commitments**\n- **Student Safety First: **Educators must ensure that the use of social media and AI supports students’ physical safety, emotional well-being, and intellectual development. This includes intervening when technology is used to harm others, teaching students to critically evaluate AI-generated content, protecting student privacy, and reporting cyberbullying, inappropriate content, and data breaches promptly.\n- **Confidentiality**: Educators must protect student privacy when using AI and social media by avoiding the sharing of personally identifiable information (PII) without appropriate consent. This includes removing metadata from images and understanding that digital content may persist indefinitely once posted.\n- **Equity and Access:** Educators must ensure AI and social media tools are equitable and accessible for all students.\n- **Professional Learning:** Educators must engage in ongoing professional learning related to AI and digital technologies. This includes learning that focuses on developing AI literacy, recognizing and mitigating bias, protecting student data, and staying current with evolving technologies and district policies.\n- **Reporting Obligations: **Educators must follow *MCEE* and district policies for reporting concerns observed through AI or social media use. This includes suspected child abuse, cyberbullying, harassment, discrimination, and other misconduct.",
				"title": "Scenario 3: Learn",
				"instruction": "First, you will read an overview to gain further insight into protecting students when using social media when you, a colleague, or a student uses AI in everyday tasks. Then, you will put that framing into practice by completing a simulation where you have a conversation with a student's guardian, whose child used AI in a questionable way. After completing the simulation, you will read feedback on how you engaged in the simulation and how your decisions aligned or came into conflict with the PROETHICS principles."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 13,
				"sourceId": 7130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104836,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing a scenario where a student uses AI in a questionable way.",
				"title": "Scenario 3: Practice",
				"scenario": "You are a 9th grade teacher. One of your students, Dylan, used an AI video creator to create content showing a classmate engaged in embarrassing behavior, posted it to social media, and circulated the video to classmates while at school.\n\nAs their teacher, you must address the situation with Dylan’s (the student who created the fake video and circulated it) parent, Mr. Smith.",
				"instruction": "You will now have a conversation with Mr. Smith. When you talk to Mr. Smith, try to help him understand the impact of Dylan’s usage of AI and social media, particularly in terms of the risk it poses to other students."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 14,
				"sourceId": 7140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104837,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 3: Simulation",
				"prompt": "You will now have a conversation with Mr. Smith. When you talk to Mr. Smith, try to help him understand the impact of Dylan’s usage of AI and social media, particularly in terms of the risk it poses to other students.",
				"persona": {
					"name": "Mr. Smith",
					"role": "Parent/Guardian",
					"description": "Mr. Smith is Dylan’s father. He wants to do the right thing but is busy, frustrated about being pulled from work, and initially reluctant to believe Dylan used AI to harm a classmate. Once he understands the severity of the situation, he is willing to hold Dylan accountable and ask how to repair the harm."
				},
				"scenario": {
					"text": "You are a 9th grade teacher. One of your students, Dylan, used an AI video creator to create content showing a classmate engaged in embarrassing behavior, posted it to social media, and circulated the video to classmates while at school.\n\nAs their teacher, you must address the situation with Dylan’s (the student who created the fake video and circulated it) parent, Mr. Smith."
				},
				"objectives": [
					"Identifying ethical issues related to the use of various artificial intelligence tools",
					"Evaluating competing tensions to make decisions aligned with ethical principles within a simulation",
					"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
				]
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_scenario",
				"language": "en-US",
				"position": 15,
				"sourceId": 7150,
				"scenarioId": "scenario-3"
			},
			"scoring": {
				"type": "AI_RUBRIC",
				"points": 12,
				"criteria": {
					"evaluates_risk_reduction_actions": {
						"icon": "clipboard-check",
						"name": "Provides evaluations of each action to clarify how it reduces that risk.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Explains why each proposed action works and how it actually lowers the risk. Shows reasoning, not just a list of steps."
					},
					"articulates_student_risk_reduction_action": {
						"icon": "shield-check",
						"name": "Specifically articulates an action to minimize risk to students when using AI systems in a specific social media situation.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Proposes a concrete action that reduces the risk the AI-generated video poses to students. Focuses on protecting the affected student and preventing further harm."
					},
					"states_social_media_ai_benefit_or_consequence": {
						"icon": "scale",
						"name": "Specifically states a clear benefit and/or negative consequence when using AI systems in a specific social media situation.",
						"points": {
							"max": 4,
							"min": 1
						},
						"description": "Names a concrete upside or harm of AI use in this exact social-media situation. Grounds the discussion in real stakes rather than abstract concerns."
					}
				}
			},
			"feedback": [
				{
					"type": "DYNAMIC",
					"language": "en-US"
				}
			],
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104838,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"title": "Scenario 3: Reflect",
				"instruction": "**Directions:** Review the feedback from your conversation with Mr. Smith to see what you did well and what can be improved."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "simulation_feedback",
				"language": "en-US",
				"position": 16,
				"sourceId": 7160,
				"scenarioId": "scenario-3"
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104839,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Human-in-the-Loop (HITL) for AI Use in K to 12 Classrooms**\n\n**Keeping educators actively involved at every critical decision point, known as a human-in-the-loop approach, is both a professional and ethical obligation when using AI in education.** AI systems can reflect bias, misinterpret context, and produce inaccurate outputs. Without human oversight, reliance on these tools can compromise instructional quality, fairness, and student trust. The *MCEE* reinforces that AI outputs should be advisory, never authoritative, and that high-stakes judgments must remain human led.\n\n**AI Data Privacy in K to 12 Classrooms**\n\n**Protecting student data privacy is a core ethical and legal responsibility whenever AI tools are used in schools**. Many AI platforms collect and store student information such as names, work samples, and performance data. Federal laws, including FERPA and COPPA, set clear boundaries on how this information may be shared, and the *MCEE* calls on teachers to use data, materials, and technology responsibly.\n\n**Decision Making Using AI and the Black Box Problem**\n\n**Educators must think critically about AI outputs because many AI systems operate as black boxes that do not reveal how or why they reach their conclusions.** When AI tools generate recommendations, they often cannot explain the reasoning behind those judgments. This lack of transparency makes it difficult for educators to verify accuracy, identify bias, and explain decisions to students and families.\n\n**Using Generative AI and Social Media Ethically**\n\n**When generative AI and social media intersect in educational settings, student safety and educator transparency must guide every decision an educator makes and informed consent must always be obtained. **AI tools can introduce bias, amplify stereotypes, spread inaccurate information, and expose students to harm through recommendation algorithms and content moderation systems. Upholding commitments to student safety, equity, confidentiality, and ongoing professional learning helps ensure that AI and social media serve students’ well-being rather than undermine it.\n\n**Applying Ethical Decision Making About AI in Your Own Practice**\n\nThe scenarios, concepts, and principles explored in this module are not abstract. They represent challenges you will encounter in your everyday practice. As you integrate AI tools into your classroom, commit to the following actions.\n- **Ensure student safety and well-being**. Before adopting any AI tool, evaluate whether it supports students’ physical, emotional, and intellectual needs.\n- **Protect student privacy.** Never enter personally identifiable information (PII) into unapproved AI tools and follow all applicable laws, district policies, and consent requirements.\n- **Be transparent.** Communicate openly with students and families about when and how AI is being used in your instruction, assessments, and communications.\n- **Think critically about AI outputs.** Treat AI-generated results as drafts, not definitive answers. Verify information against credible sources and your own professional knowledge before acting on it.\n- **Stay in the loop.** Maintain active oversight at every stage, from vetting and selecting AI tools to interpreting outputs and making final decisions. Never give up your professional judgment to an algorithm.\n- **When in doubt, pause.** Ask yourself questions, consult colleagues and administrators, and reflect on the ethical implications before proceeding. When using AI, ethical decision making is an ongoing commitment that strengthens your practice, builds trust, and models responsible technology use for the students you serve.",
				"title": "Module 7 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 17,
				"sourceId": 7170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104840,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Miller, a first-year high school English teacher, uses a new AI-powered writing detector integrated into the school’s learning management system. The AI flags one of his top students’ research papers as “highly likely written by AI or plagiarized,” even though Mr. Miller knows the student to be an excellent writer. Mr. Miller is pressed for time and wonders how to respond.\n\nWhich of the following best describes the most ethical action for Mr. Miller to take?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 18,
				"sourceId": 7180
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "701e6818-182f-4d45-87a7-e4d4581df8e8",
						"isCorrect": false
					},
					{
						"choiceId": "dff35948-78c1-4aff-80d4-9b4f00f7756b",
						"isCorrect": true
					},
					{
						"choiceId": "22620e66-7877-490a-927f-735ba71a170b",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "dff35948-78c1-4aff-80d4-9b4f00f7756b",
					"detailed": {
						"text": "Mr. Miller is in the loop when deciding how to handle a plagiarism concern. It is important to double-check any automated cheating flags by talking to the student and using your own expertise before taking action. That way, you ensure fairness by verifying that the AI’s suspicion is valid and not a mistake."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "701e6818-182f-4d45-87a7-e4d4581df8e8",
						"text": "Trust the AI’s detection as objective evidence and report the student for plagiarism without further investigation.",
						"numFirstSelections": 0
					},
					{
						"id": "dff35948-78c1-4aff-80d4-9b4f00f7756b",
						"text": "Recognize the AI flag as preliminary, then review the research paper and sources and speak with the student to understand their writing process before making any decisions.",
						"numFirstSelections": 0
					},
					{
						"id": "22620e66-7877-490a-927f-735ba71a170b",
						"text": "Ignore the AI flag entirely because he believes the student is honest; grade the paper and do not mention the issue.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104841,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Alvarez, a new middle school teacher, decides to use a free AI text generator to help grade student essays more quickly. He plans to copy sections of his students’ essays into the AI platform to get immediate feedback and scores. He believes this will save time and considers it acceptable since he intends to remove student names from the text.\n\nWhich of the following is the most ethical course of action for Mr. Alvarez in this situation?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 19,
				"sourceId": 7190
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "fa335dee-9fb4-41df-9885-93662235217e",
						"isCorrect": false
					},
					{
						"choiceId": "fe3d2d99-022c-4abf-a71c-90578fbe3cd3",
						"isCorrect": false
					},
					{
						"choiceId": "0a1dd6bb-f30b-41f6-ac1a-76c61d6d6846",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "0a1dd6bb-f30b-41f6-ac1a-76c61d6d6846",
					"detailed": {
						"text": "Mr. Alvarez protects student data privacy and complies with school policy and federal laws by seeking formal approval and guidance on district-vetted tools. He should rely on professional expertise or approved methods rather than inappropriately outsourcing grading to an unapproved AI."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "fa335dee-9fb4-41df-9885-93662235217e",
						"text": "Use the AI to grade student essays, as long as he strips out any student names to protect privacy.",
						"numFirstSelections": 0
					},
					{
						"id": "fe3d2d99-022c-4abf-a71c-90578fbe3cd3",
						"text": "Ask the AI tool for quick feedback on student writing, but double-check the AI’s suggestions himself before sharing anything with students.",
						"numFirstSelections": 0
					},
					{
						"id": "0a1dd6bb-f30b-41f6-ac1a-76c61d6d6846",
						"text": "Refrain from uploading any student work into a public AI platform without formal approval and instead seek district-approved feedback tools or rely on his own professional grading.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104842,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A new seventh-grade teacher, Ms. Robinson, uses her district’s AI-driven system that predicts which students might struggle academically based on grades and behavior data. The AI identifies a student, Darnell, as “high risk” for failing mathematics but provides no explanation. Ms. Robinson is surprised because Darnell generally participates well in class. The vice principal advises her to follow the data and immediately place Darnell in daily remedial mathematics support.\n\nWhich of the following best describes Ms. Robinson’s most ethical response?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 20,
				"sourceId": 7200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "0a1d20e7-e2c1-42ef-85a3-889bd422f2b9",
						"isCorrect": true
					},
					{
						"choiceId": "c6a93307-8e7b-401a-aab8-e73447eba60e",
						"isCorrect": false
					},
					{
						"choiceId": "25730ca2-818d-4635-9136-d9c57aab6e02",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "0a1d20e7-e2c1-42ef-85a3-889bd422f2b9",
					"detailed": {
						"text": "Ms. Robinson stays actively involved in the decision about Darnell’s placement instead of accepting the computer’s prediction. By gathering more evidence and understanding how the AI came to its conclusion, she can make a more informed and fair placement decision for the student, which protects them from potential mistakes made by a black box algorithm."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "0a1d20e7-e2c1-42ef-85a3-889bd422f2b9",
						"text": "Gather multiple pieces of data, including Darnell’s classwork and information from his previous teachers, to inform the most appropriate placement.",
						"numFirstSelections": 0
					},
					{
						"id": "c6a93307-8e7b-401a-aab8-e73447eba60e",
						"text": "Place Darnell in daily remedial mathematics support to ensure his success.",
						"numFirstSelections": 0
					},
					{
						"id": "25730ca2-818d-4635-9136-d9c57aab6e02",
						"text": "Keep Darnell in the regular math class based on his current level of success in the classroom.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104843,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Oliver uses a teacher dashboard that gives her real‑time visibility into students’ online activity during class. The tool allows her to see open tabs, close off‑task websites, and pause Internet access for individual students. Over several classes, she notices that she is redirecting and restricting Internet access for the same small group of students more frequently than others. After reflecting, she realizes these students are from the same cultural and linguistic background, and she is unsure whether her responses are fully objective.\n\nWhich of the following is Ms. Oliver’s most ethically appropriate next step?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 21,
				"sourceId": 7210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "69c52f7b-cf34-4951-a53e-280adf14db50",
						"isCorrect": true
					},
					{
						"choiceId": "7f718da5-c359-4c41-8592-931123685748",
						"isCorrect": false
					},
					{
						"choiceId": "64166738-df41-4c8c-ba19-f606f67212a4",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "69c52f7b-cf34-4951-a53e-280adf14db50",
					"detailed": {
						"text": "Ms. Oliver has a responsibility to ensure that her use of monitoring tools supports student welfare and equity. Ethical practice requires reflection, consistent application of expectations, and professional consultation when patterns raise concerns about objectivity. By reviewing her decisions and consulting with an administrator, she mitigates risk while continuing to guide students responsibly."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "69c52f7b-cf34-4951-a53e-280adf14db50",
						"text": "Reflect on her decision‑making patterns and discuss her observations with an administrator to ensure objectivity.",
						"numFirstSelections": 0
					},
					{
						"id": "7f718da5-c359-4c41-8592-931123685748",
						"text": "Stop using the dashboard features altogether to avoid the appearance of bias.",
						"numFirstSelections": 0
					},
					{
						"id": "64166738-df41-4c8c-ba19-f606f67212a4",
						"text": "Rely on the dashboard’s visibility alone, since seeing student activity in real time removes the possibility of bias.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 104844,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Park uses an AI-powered monitoring tool that flags a student post containing an AI-generated image depicting self-harm. The student insists they are fine and says they created the image “just to see what it looked like.”\n\nWhich of the following is Ms. Park’s most ethical course of action?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 22,
				"sourceId": 7220
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "f06f4ada-8ffb-450a-bc2c-25acc5ce993a",
						"isCorrect": false
					},
					{
						"choiceId": "0ba680b9-30db-40b9-b22a-5a41504b32ae",
						"isCorrect": true
					},
					{
						"choiceId": "d96370f7-7fe6-4c6d-a204-6925ab18657a",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "0ba680b9-30db-40b9-b22a-5a41504b32ae",
					"detailed": {
						"text": "Any content suggesting self-harm represents a potential safety risk, regardless of intent. Ms. Park must follow reporting protocols and refer the concern to trained professionals. Educators are not responsible for assessing mental health risk independently."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "f06f4ada-8ffb-450a-bc2c-25acc5ce993a",
						"text": "Accept the explanation and monitor the situation.",
						"numFirstSelections": 0
					},
					{
						"id": "0ba680b9-30db-40b9-b22a-5a41504b32ae",
						"text": "Report the incident to the school counselor or appropriate professional and follow district protocol.",
						"numFirstSelections": 0
					},
					{
						"id": "d96370f7-7fe6-4c6d-a204-6925ab18657a",
						"text": "Delete the post and warn the student not to create similar content.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37093,
					"label": "Module 7: The Professional Educator and AI",
					"title": "Module 7: The Professional Educator and AI",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 7: The Professional Educator and AI",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "baa9bf0d-a1b3-4932-8852-a679d3bcb995",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
